import React, {
    // useEffect, 
    useRef, useState
} from 'react';
import Modal from 'react-bootstrap/Modal';

// import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'


import axios from "axios";
import useTableScroll from "../useTableScroll";
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import { validaSoloNumero } from '../../util/varios';
import moment from 'moment';
import CatalogoContable from '../../catalogos/catalogoContable';


const ImpModal = props => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem("jwtToken");

    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idorganizacion = JSON.parse(localStorage.getItem('idorganizacion'));
    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
    const riforg = JSON.parse(localStorage.getItem('riforg'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));

    const txtId4 = useRef();
    const txtDescrip4 = useRef();
    const check1 = useRef();
    const check2 = useRef();
    const check3 = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const cmbTipoIngreso = useRef();
    const btnCancela = useRef();
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [operacion, setOperacion] = useState()
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);

    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [tipoIngreso, setTipoIngreso] = useState()

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCIÓN', textAlign: 'center' },
        { label: 'AÑO', textAlign: 'center' },
    ]

    const {
        // TblContainer,
        // TblHead,
        // TblPagination,
        // recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    // const handleSearch = e => {
    //     let target = e.target;

    //     setFilterFn({
    //         fn: items => {
    //             if (target.value === "") {
    //                 return items;
    //             } else {
    //                 return items.filter(x => {
    //                     if (x.idefiscal.includes(target.value)
    //                         || x.descriptor.toLowerCase().includes(target.value.toLowerCase())) {
    //                         return x;
    //                     }
    //                 });
    //             }
    //         }
    //     })

    // }



    const seleccionarEjercicioFiscal = () => {

        setActivate(true);

        let campos = '*';
        let nomtab = 'efiscal';
        let orden = 'anio desc';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                var clase = []
                for (let i = 0; i < response.data.length; i++) {
                    clase.push({
                        idefiscal: response.data[i].idefiscal,
                        descriptor: response.data[i].descriptor,
                        anio: response.data[i].anio,
                        observaciones: response.data[i].observaciones,
                        statusorg: response.data[i].statusorg,
                        statuspresup: response.data[i].statuspresup,
                        statuspuc: response.data[i].statuspuc,
                        statuscat: response.data[i].statuscat,
                        idorganizacion: response.data[i].idorganizacion,
                        activo: response.data[i].activo,
                    })
                }
                setRecords(clase)

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);

        })
    }

    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setOperacion(0)
        setFilterFn({ fn: items => { return items; } });
    }

    const cancelar = () => {
        props.setShow(false)
        blanquear();
    }

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        blanquear();
        props.setShow(false)
    }

    const imprimir = () => {

        let reporte = '';
        let sql = '';
        let sql1 = '';
        let sql2 = '';
        let sql3 = '';
        let sql4 = '';
        let sql5 = '';
        let titulo = '';
        let titulo2 = '';
        let tiprep = ''

        let desde = ''
        let hasta = '';


        if (operacion === 28) {
            desde = moment.utc(txtDesde.current.value).format('DD/MM/YYYY');


            reporte = 'Conta_Balance_Comprobacion'

            if (check1.current && check1.current.checked) {

                sql = "Fecha <= '" + desde.toString() + "'";
                sql1 = "gru > '0'";
                sql2 = "'" + desde.toString() + "'";

            } else if (check2.current.checked) {

                sql = "tipo = 0";
                sql1 = "gru < '3'";
                sql2 = "";


            } else if (check3.current.checked) {

                sql = "Fecha < DATE ('01' || substr('" + desde.toString() + "',3,8))";
                sql1 = "gru > '0'";
                sql2 = "'" + desde.toString() + "'";
                sql3 = "fecha BETWEEN DATE ( '01' || substr('" + desde.toString() + "',3,8)) AND DATE ('" + desde.toString() + "')";


            }

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&CONDICION=${sql}&CONDICION1=${sql1}&CONDICION2=${sql3}&TITFEC=${sql2}&RIF=${riforg}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 29) {

            //desde = moment.utc(txtDesde.current.value).format('DD/MM/YYYY');
            let val1 = "01/01/" + txtDesde.current.value.substring(0, 4);
            let val2 = moment.utc(txtDesde.current.value).format('DD/MM/YYYY');

            reporte = 'Conta_Balance_General'

            if (check1.current && check1.current.checked) {

                sql = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo >= 0";
                sql1 = "true";
                sql2 = val2;
                sql3 = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo <= 6";
                tiprep = "1";
                sql4 = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo < 7";

            } else if (check2.current.checked) {

                sql = "tipo = 0";
                sql1 = "true";
                sql2 = "";
                sql3 = "tipo = 0";
                tiprep = "2";
                sql4 = "tipo = 0";

            } else if (check3.current.checked) {

                sql = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo <= 6";
                sql1 = "true";
                sql2 = "'" + val2 + "'";
                sql3 = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo <= 6";
                tiprep = "3";
                sql1 = "true";
                sql4 = "fecha >= " + "'" + val1 + "'" + " AND fecha <=" + "'" + val2 + "'" + " AND tipo >= 0";

            }

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&CONDICION=${sql}&CONDICION1=${sql1}&CONDICION2=${sql3}&CONDICION3=${sql4}&TITFEC=${sql2}&TIPOREPORT=${tiprep}&RIF=${riforg}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 30) {

            desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
            hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');


            sql = "Between '" + desde.toString() + "' and '" + hasta.toString() + "'";

            sql2 = " Desde " + desde.toString() + "  Hasta " + hasta.toString() + " ";

            if (desde === hasta) {
                sql2 = " Del día " + desde, toString();
            }

            if (check1.current && check1.current.checked) {
                reporte = 'Asientos';
            } else {
                reporte = 'AsientosPub21';
            }

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&FECHA=${sql}&TIT=${sql2}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 31) {

            desde = moment.utc(txtDesde.current.value).format('DD/MM/YYYY');

            if (desde.substring(3, 5) == "01") {
                sql = "fecha >= DATE ('01' || substr('" + desde.toString() + "',3,8)) AND tipo = 0 ";
                sql3 = "fecha BETWEEN DATE ('01' || substr('" + desde.toString() + "',3,8)) AND DATE ('" + desde.toString() + "') AND tipo > 0";
            } else {
                sql = "fecha < DATE ('01' || substr('" + desde.toString() + "',3,8)) ";
                sql3 = "fecha BETWEEN DATE ('01' || substr('" + desde.toString() + "',3,8)) AND DATE ('" + desde.toString() + "')";
            }

            sql1 = "gru <= '3'";
            sql2 = desde;

            if (check1.current && check1.current.checked) {
                reporte = 'Conta_Estado_Movimiento';
            } else {
                reporte = 'Conta_Estado_Movimiento_Cuentas';
            }

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&CONDICION=${sql}&CONDICION1=${sql1}&TITFEC=${sql2}&CONDICION2=${sql3}&RIF=${riforg}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 32) {
            if (txtDescrip4.current.value === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar una Cuenta Contable.', icono: 'informacion' })
                return;
            }
            desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
            hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

            sql = "a.Fecha Between" + "'" + desde.toString() + "'" + " AND " + "'" + hasta.toString() + "'";
            sql2 = "DESDE EL" + " " + desde.toString() + " " + "HASTA EL" + " " + hasta.toString();

            if (desde.substring(3, 5) == "01") {
                sql1 = "fecha >= DATE ('01' || substr('" + desde.toString() + "',3,8)) AND tipo = 0 ";
                sql = "a.Fecha Between" + "'" + desde.toString() + "'" + " AND " + "'" + hasta.toString() + "' AND mc.tipo > 0";
            } else {
                sql1 = "fecha < DATE ('01' || substr('" + desde.toString() + "',3,8)) ";
                sql = "a.Fecha Between" + "'" + desde.toString() + "'"
                    + " AND " + "'" + hasta.toString() + "'";

            }
            
            sql1 = "gru <= '3'";
            sql2 = desde;

            if (check1.current && check1.current.checked) {
                reporte = 'Conta_Estado_Movimiento';
            } else {
                reporte = 'Conta_Estado_Movimiento_Cuentas';
            }

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&CONDICION=${sql}&CONDICION1=${sql1}&TITFEC=${sql2}&CONDICION2=${sql3}&RIF=${riforg}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 34) {

            reporte = 'Asientos_Egreso';

            let idcheque = txtId4.current && txtId4.current.value;

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&efiscal=${idefiscal}&idcheque=${idcheque}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 35) {

            reporte = 'Geco_Analisis'

            if (parseInt(cmbTipoIngreso.current.value) === 0) {
                titulo = 'ACTIVIDADES ECONOMICAS';
                titulo2 = 'COMERCIO'
            } else if (parseInt(cmbTipoIngreso.current.value) === 1) {
                titulo = 'INMUEBLES URBANOS'
                titulo2 = 'INMUEBLE'


            }

            desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
            hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

            sql = "FchPago Between '" + desde + "' AND '" + hasta + "'";
            sql2 = "FchPago >= '" + hasta + "'";
            sql3 = "origen = '" + titulo2 + "'";
            sql4 = efiscalanio;
            sql5 = "DESDE EL '" + desde + "' HASTA EL '" + hasta + "'";

            window.open(`${op.reportes + "/contabilidadfiscal?"}reporte=${reporte}&CONDICION=${sql}&ORIG=${sql3}&CONDIFECHA=${sql2}&CRITERIO=${titulo}&MANIO=${sql4}&RANGO=${sql5}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        }

    };

    const selectNaturaleza = (id) => (e) => {
        e.preventDefault()

        let endpoint = `${op.conexion}/api/contabilidadfis/selectnaturaleza?idefiscal=${id}&efiscalanio=${efiscalanio}`;

        setActivate(true);


        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                /*  crearCuentasContables(response.data) */
                setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Operación exitosa', icono: 'informacion' })

                console.log('exitoso')

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }



    const cargarEjercicio = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        let endpoint = `${op.conexion}/api/contabilidadfis/cargardesdeejercicio`;

        setActivate(true);

        let body = {
            idefiscal: values[0].idefiscal,
            efiscal: idefiscal
        };

        console.log(body)


        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {


                if (operacion === 28) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El plan de cuenta fúe cargado', icono: 'exito' })

                } else if (operacion === 30) {
                    selectNaturaleza(values[0].idefiscal)

                }



            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }

    const cargarVinculacion = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        let endpoint = `${op.conexion}/api/contabilidadfis/seleccionarpuc?idefiscal=${values[0].idefiscal}`;
        let body;
        setActivate(true);


        axios.post(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Vinculación Cargada', icono: 'exito' })

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })


    }

    const datosRes = () => {
        let campos = '*';
        let nomtab = 'efiscal';
        let nomid = 'idefiscal';
        let nomid2 = 'idorganizacion';
        let id2 = idorganizacion;

        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${values[0].idefiscal}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                console.log(response.data[0])
                localStorage.setItem('efiscaldes', response.data[0].descriptor);
                localStorage.setItem('efiscalanio', response.data[0].anio);
                localStorage.setItem('idefiscal', values[0].idefiscal);
                localStorage.setItem('statuscat', response.data[0].statuscat);
                localStorage.setItem('statusorg', response.data[0].statusorg);
                localStorage.setItem('statuspresup', response.data[0].statuspresup);
                localStorage.setItem('statuspuc', response.data[0].statuspuc);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Cambio realizado con exito', icono: 'exito' })










            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const cargar = () => {

        console.log(operacion)

        if (operacion === 32) {
            cargarVinculacion()
        } else if (operacion === 45) {
            datosRes()
        } else if (operacion === 28 || operacion === 30) {
            cargarEjercicio()
        }

    }

    const seleccionarCuenta = (id) => {

        setMostrar3(false)

        let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;

        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {



                if (response.data !== '') {

                    console.log(response.data)

                    txtId4.current.value = response.data.idcuentacontable;
                    txtDescrip4.current.value = response.data.codigocuenta;


                    setActivate(false);

                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
                    /*    txtDescripcion.current.value = ''; */
                    setActivate(false);
                }
            }

        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const validarCuenta = (event) => {
        event.preventDefault();
        txtDescrip4.current.value = "";
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {

                seleccionarCuenta(event.target.value);

            } else {

                /*  cmbTipo.current.value = ''; */
                /*   txtCuentaContable.current.value = '';
                  txtDescripcion.current.value = ''; */
            }
        }
    };

    const selecionarRegistros = () => {
        let nomtab = 'tipoimpuesto';
        let nomid = 'idtipoingreso';
        let nomtab2 = 'tipoingreso';
        let nomid2 = 'idtipoingreso';

        let endpoint = `${op.conexion}/api/consulta/seleccionarregistros3?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}`;
        setActivate(true);

        // Cambia axios.post a axios.get
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            if (response.status == 200) {
                console.log(response.data);
                setTipoIngreso(response.data);
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            // Manejo más seguro del error
            if (error.response) {
                // El servidor respondió con un código de estado fuera del rango 2xx
                setMensaje({
                    mostrar: true,
                    titulo: 'ERROR',
                    texto: error.response.data.message || 'Error en la solicitud',
                    icono: 'error'
                });
            } else if (error.request) {
                // La solicitud fue hecha pero no se recibió respuesta
                setMensaje({
                    mostrar: true,
                    titulo: 'ERROR',
                    texto: 'No se recibió respuesta del servidor',
                    icono: 'error'
                });
            } else {
                // Algo pasó al configurar la solicitud
                setMensaje({
                    mostrar: true,
                    titulo: 'ERROR',
                    texto: error.message || 'Error al configurar la solicitud',
                    icono: 'error'
                });
            }
        });
    }


    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarEjercicioFiscal();
                setSelect(parseInt(idefiscal));
                setOperacion(props.operacion)

                selecionarRegistros()

            }}
        >
            {/* {11===28} */}
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light">{
                    operacion === 28 ? 'Balance de Comprobación de la hacienda de Pública Municipal'
                        : operacion === 29 ? 'Balance de General de la hacienda de Pública Municipal'
                            : operacion === 30 ? 'Asientos Contables'
                                : operacion === 31 ? 'Estado de Movimientos de la Hacienda de Pública Municipal'
                                    : operacion === 32 ? 'Mayor Analitico'
                                        : operacion === 33 ? 'Asientos del Egreso'
                                            : operacion === 34 ? 'Análisis de Deuda de Lenta y Dificil Recaudación'
                                                : ''
                } </div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Notificación.' ? cargar() : mensaje.titulo === 'Exito.' ? cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 row mx-auto">
                    {operacion === 30 || operacion === 32 || operacion === 34 ?

                        <div className='col-md-12 row mx-auto px-0'>
                            <div className="input-group input-group-sm mb-3 col-md-6">
                                <span className="input-group-text" id="inputGroup-sizing-sm">Desde:</span>
                                <input type="date" className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={moment.utc(fechasistema).format('YYYY-MM-DD')} max={moment.utc(fechasistema).format('YYYY/MM/DD')} ref={txtDesde} />

                            </div>
                            <div className="input-group input-group-sm mb-3 col-md-6">
                                <span className="input-group-text" id="inputGroup-sizing-sm">Hasta:</span>
                                <input type="date" className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={moment.utc(fechasistema).format('YYYY-MM-DD')} max={moment.utc(fechasistema).format('YYYY/MM/DD')} ref={txtHasta} />

                            </div>
                        </div>

                        :

                        operacion === 33 ? ''

                            :

                            <div className='col-md-12 row mx-auto px-0'>
                                <div className="input-group input-group-sm mb-3 col-md-6 mx-auto">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Al dia:</span>
                                    <input type="date" className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={moment.utc(fechasistema).format('YYYY-MM-DD')} max={moment.utc(fechasistema).format('YYYY/MM/DD')} ref={txtDesde} />
                                </div>

                            </div>



                    }



                    {operacion === 28 ?
                        <div className='col-md-12 row mx-auto'>
                            <div className="form-check col">
                                <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault1" ref={check1} defaultChecked />
                                <label className="form-check-label my-auto" for="flexRadioDefault1">
                                    Movimientos
                                </label>
                            </div>
                            <div className="form-check col">
                                <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault2" ref={check2} />
                                <label className="form-check-label my-auto" for="flexRadioDefault2">
                                    Apertura
                                </label>
                            </div>

                            <div className="form-check col">
                                <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault3" ref={check3} />
                                <label className="form-check-label my-auto" for="flexRadioDefault3">
                                    Nivel Cuentas
                                </label>
                            </div>

                        </div>
                        :
                        operacion === 29 ?
                            <div className='col-md-12 row mx-auto'>




                                <div className="form-check col">
                                    <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault1" ref={check1} defaultChecked />
                                    <label className="form-check-label my-auto" for="flexRadioDefault1">
                                        Movimientos
                                    </label>
                                </div>
                                <div className="form-check col">
                                    <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault2" ref={check2} />
                                    <label className="form-check-label my-auto" for="flexRadioDefault2">
                                        Apertura
                                    </label>
                                </div>

                                <div className="form-check col">
                                    <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault3" ref={check3} />
                                    <label className="form-check-label my-auto" for="flexRadioDefault3">
                                        Cierre
                                    </label>
                                </div>

                            </div>
                            :
                            operacion === 30 ?
                                <div className='col-md-12 row mx-auto'>
                                    <div className="form-check col">
                                        <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault1" ref={check1} defaultChecked />
                                        <label className="form-check-label my-auto" for="flexRadioDefault1">
                                            Formato General
                                        </label>
                                    </div>
                                    <div className="form-check col">
                                        <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault2" ref={check2} />
                                        <label className="form-check-label my-auto" for="flexRadioDefault1">
                                            Formato SubCuenta
                                        </label>
                                    </div>



                                </div>
                                :
                                operacion === 31 ?
                                    <div className='col-md-12 row mx-auto'>
                                        <div className="form-check col-md-5">
                                            <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault1" ref={check1} defaultChecked />
                                            <label className="form-check-label my-auto" for="flexRadioDefault1">
                                                Nivel Rubro
                                            </label>
                                        </div>
                                        <div className="form-check col">
                                            <input className="form-check-input my-auto" type="radio" name="flexRadioDefault" id="flexRadioDefault2" ref={check2} />
                                            <label className="form-check-label my-auto" for="flexRadioDefault1">
                                                Nivel Cuenta Movimiento
                                            </label>
                                        </div>



                                    </div>
                                    :
                                    operacion === 32 || operacion === 33 ?
                                        <div className='col-md-12 mx-auto input-group input-group-sm'>



                                            <label className="input-group-text" id="inputGroup-sizing-sm">Código Cuenta:</label>
                                            <input type="text" name='idcuentabancaria' className="form-control col-md-2 " onKeyUp={validarCuenta} onBlur={validarCuenta} ref={txtId4} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                                            <button type="button" onClick={() => { setMostrar3(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                                            <input type="text" className="form-control rounded" id='codigocuenta' disabled name='codigocuenta' ref={txtDescrip4}    /* value={values.codigocuenta} */ /* onKeyUp={handleInputNumChange} */ /* onChange={handleInputNumChange} */  ></input>



                                        </div>
                                        :

                                        operacion === 34 ?
                                            <div className='col-md-12 mx-auto input-group input-group-sm'>



                                                <label className="input-group-text" id="inputGroup-sizing-sm">Tipo Ingreso:</label>
                                                <select className="form-select" ref={cmbTipoIngreso} aria-label="Default select example">

                                                    <option value='0'>COMERCIO</option>
                                                    <option value='1'>INMUEBLE</option>


                                                </select>



                                            </div>
                                            :


                                            ''


                    }


                    <CatalogoContable
                        llamado={1}
                        show={mostrar3}
                        onHideCancela={() => { setMostrar3(false) }}
                        onHideAcepta={seleccionarCuenta}

                    />

                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-primary rounded-pill" style={{ margin: "5px" }} onClick={imprimir}><i className="fas fa-print"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default ImpModal;